import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainNavbar = _resolveComponent("MainNavbar")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_MenuClassic = _resolveComponent("MenuClassic")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainNavbar, { class: "style-three" }),
    _createVNode(_component_PageTitle, {
      pageTitle: "Menu",
      mainTitle: "Menu",
      subTitle: "Where Every Dish Tells A Unique Tale"
    }),
    _createVNode(_component_MenuClassic)
  ], 64))
}